import { render } from "./VideoCreationWizard.vue?vue&type=template&id=2f39db19&scoped=true"
import script from "./VideoCreationWizard.vue?vue&type=script&lang=js"
export * from "./VideoCreationWizard.vue?vue&type=script&lang=js"

import "./VideoCreationWizard.vue?vue&type=style&index=0&id=2f39db19&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f39db19"]])

export default __exports__